module.exports = __webpack_public_path__ + "img/pos--icon.6003bc48.svg";